import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDataflow04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.032 1H5.968c-.439 0-.817 0-1.13.021a3.07 3.07 0 0 0-.986.207 3 3 0 0 0-1.624 1.624 3.07 3.07 0 0 0-.207.986C2 4.15 2 4.529 2 4.968v.064c0 .439 0 .817.021 1.13.023.33.072.66.207.986a3 3 0 0 0 1.624 1.624c.326.135.656.184.986.207C5.15 9 5.529 9 5.968 9H11v3H8.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564a19.07 19.07 0 0 0-.043 1.423 3.001 3.001 0 1 0 2 0c.002-.529.01-.93.037-1.26.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18C7.361 14 7.943 14 8.8 14H11v3.17a3.001 3.001 0 1 0 2 0V14h2.2c.857 0 1.439 0 1.889.038.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819.027.33.035.731.037 1.26A3.001 3.001 0 0 0 20 23a3 3 0 0 0 1-5.83 19.079 19.079 0 0 0-.044-1.422c-.046-.562-.145-1.079-.392-1.564a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 12 16.046 12 15.242 12H13V9h5.032c.439 0 .817 0 1.13-.021.33-.023.66-.072.986-.207a3 3 0 0 0 1.624-1.624c.135-.326.184-.656.207-.986C22 5.85 22 5.471 22 5.032v-.064c0-.439 0-.817-.021-1.13a3.072 3.072 0 0 0-.207-.986 3 3 0 0 0-1.624-1.624 3.07 3.07 0 0 0-.986-.207C18.85 1 18.471 1 18.032 1Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgDataflow04.displayName = 'Dataflow04';
export default SvgDataflow04;
